/* Sticker Cartel theme scripts */
(function () {
  function money(n) { return '$' + n.toFixed(2); }
  function addToCart(variantId, properties, goCheckout, msgEl, btn) {
    if (btn) btn.disabled = true;
    if (msgEl) { msgEl.textContent = 'Adding…'; msgEl.style.color = ''; }
    var body = { items: [{ id: variantId, quantity: 1, properties: properties || {} }] };
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); }); return r.json(); })
      .then(function () {
        if (goCheckout) { window.location.href = '/checkout'; return; }
        if (msgEl) msgEl.innerHTML = 'Added. <a class="link-accent" href="/cart">View cart →</a>';
        var count = document.querySelector('.cart-count');
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var link = document.querySelector('a[href="/cart"].icon-btn');
          if (!link) return;
          if (!count) { count = document.createElement('span'); count.className = 'cart-count'; link.appendChild(count); }
          count.textContent = c.item_count;
        });
      })
      .catch(function (e) { if (msgEl) { msgEl.textContent = e.message + '. Try again or contact the shop.'; msgEl.style.color = 'var(--destructive)'; } })
      .finally(function () { if (btn) btn.disabled = false; });
  }
  function findVariant(list, opts) {
    return (list || []).find(function (v) { return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; }); });
  }

  function readJSON(el) {
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }


  // Scroll reveal for major blocks
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var targets = document.querySelectorAll('main section, main .pm-layout > *, main .card-panel, main .box, main .stat');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    targets.forEach(function (t, i) {
      if (t.closest('.pm-lightbox')) return;
      if (i < 3 && t.getBoundingClientRect().top < window.innerHeight) return; // don't hide above-the-fold
      t.classList.add('reveal');
      io.observe(t);
    });
  })();


  // Brand strip: fade between logos in each slot
  document.querySelectorAll('[data-brand-slot]').forEach(function (slot) {
    var logos = slot.querySelectorAll('.brand-logo');
    if (logos.length < 2) return;
    var row = slot.closest('.brand-strip__row');
    var interval = 3000;
    if (row) {
      var v = getComputedStyle(row).getPropertyValue('--brand-interval').trim();
      if (v) interval = parseInt(v, 10) || 3000;
    }
    var i = 0, timer = null;
    function step() {
      logos[i].classList.remove('is-on');
      i = (i + 1) % logos.length;
      logos[i].classList.add('is-on');
    }
    function start() { if (!timer) timer = setInterval(step, interval); }
    function stop() { clearInterval(timer); timer = null; }
    setTimeout(start, (parseInt(slot.dataset.delay, 10) || 0) * 600);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    slot.addEventListener('mouseenter', stop);
    slot.addEventListener('mouseleave', start);
  });


  // Header: shrink slightly once the page scrolls
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var tick = false;
    function onScroll() {
      if (tick) return; tick = true;
      requestAnimationFrame(function () { header.classList.toggle('is-stuck', window.scrollY > 24); tick = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();


  // Header dropdowns: tap to open on touch devices
  document.querySelectorAll('[data-drop]').forEach(function (d) {
    var trigger = d.querySelector('.has-drop__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: hover)').matches) return;
      if (!d.classList.contains('is-open')) { e.preventDefault(); d.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
    });
    document.addEventListener('click', function (e) {
      if (!d.contains(e.target)) { d.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
    });
  });


  // Term carousel arrows
  document.querySelectorAll('[data-term-rail]').forEach(function (rail) {
    var wrap = rail.closest('.terms');
    if (!wrap) return;
    function step(dir) {
      var card = rail.querySelector('.term');
      var w = card ? card.getBoundingClientRect().width + 20 : 300;
      rail.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    }
    var prev = wrap.querySelector('[data-term-prev]'), next = wrap.querySelector('[data-term-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });

  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
  });

  // Option-button groups (shared helper)
  function bindOptions(root, onChange) {
    root.querySelectorAll('[data-option-group]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn) return;
        group.querySelectorAll('[data-value]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        onChange();
      });
    });
  }
  function selected(root, name) {
    var btn = root.querySelector('[data-option-group="' + name + '"] [aria-pressed="true"]');
    return btn ? btn : null;
  }

  // Die-cut sticker builder
  document.querySelectorAll('[data-sticker-builder]').forEach(function (root) {
    var cfgEl = root.querySelector('script[type="application/json"]');
    var cfg = cfgEl ? readJSON(cfgEl) : null;
    if (!cfg) return;
    var totalEl = root.querySelector('[data-total]');
    var eachEl = root.querySelector('[data-each]');
    var summaryEl = root.querySelector('[data-summary]');
    var cta = root.querySelector('[data-order-link]');
    var checkoutBtn = root.querySelector('[data-checkout]');
    var addBtn = root.querySelector('[data-add-cart]');
    var msg = root.querySelector('[data-cart-msg]');
    var current = null;

    function discountFor(qty) {
      var d = 1;
      cfg.discounts.forEach(function (t) { if (qty >= t.qty) d = t.mult; });
      return d;
    }
    function update() {
      var shapeBtn = selected(root, 'shape'), sizeBtn = selected(root, 'size'), qtyBtn = selected(root, 'qty');
      if (!shapeBtn || !sizeBtn || !qtyBtn) return;
      var mult = parseFloat(shapeBtn.dataset.mult), base = parseFloat(sizeBtn.dataset.base), qty = parseInt(qtyBtn.dataset.value, 10);
      var each = base * mult * discountFor(qty);
      var total = each * qty;
      current = findVariant(cfg.variants, [shapeBtn.dataset.value, sizeBtn.dataset.value, qty + ' stickers']);
      if (current) { total = current.price / 100; each = total / qty; }
      totalEl.textContent = money(total);
      eachEl.textContent = money(each) + ' each';
      var canBuy = !!(current && current.available);
      checkoutBtn.hidden = !canBuy; addBtn.hidden = !canBuy;
      if (msg) msg.textContent = '';
      var summary = 'Matte vinyl, ' + shapeBtn.dataset.value + ', ' + sizeBtn.dataset.value + ', ' + qty + ' stickers, free printed proof';
      summaryEl.textContent = summary;
      if (cta && cta.dataset.base) {
        var url = cta.dataset.base + (cta.dataset.base.indexOf('?') > -1 ? '&' : '?') +
          'product=' + encodeURIComponent('Die-cut stickers (100 min)') +
          '&quantity=' + qty +
          '&details=' + encodeURIComponent(shapeBtn.dataset.value + ' ' + sizeBtn.dataset.value + ' die-cut stickers, estimate ' + money(each * qty));
        cta.setAttribute('href', url);
      }
    }
    bindOptions(root, update);
    checkoutBtn.addEventListener('click', function () { if (current) addToCart(current.id, {}, true, msg, checkoutBtn); });
    addBtn.addEventListener('click', function () { if (current) addToCart(current.id, {}, false, msg, addBtn); });
    update();
  });

  // Premade bags catalogue
  document.querySelectorAll('[data-premade]').forEach(function (root) {
    var cfg = readJSON(root.querySelector('script[type="application/json"]'));
    if (!cfg) return;
    var grid = root.querySelector('[data-design-grid]');
    var sheet = root.querySelector('[data-price-sheet]');
    var countLabel = root.querySelector('[data-count-label]');
    var state = { orient: 'standard', design: null };

    function orientLabel() { return state.orient === 'standard' ? cfg.labels.standard : cfg.labels.sideways; }

    function renderGrid() {
      var list = cfg.designs[state.orient];
      countLabel.textContent = list.length + ' designs, ' + orientLabel() + ', ' + cfg.minimum + ' bag minimum';
      grid.innerHTML = '';
      list.forEach(function (d, i) {
        var id = i + 1;
        var hue = cfg.hues[id % cfg.hues.length];
        var active = state.design === d.name;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'card-panel design-card' + (active ? ' is-active' : '');
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        var art = document.createElement('div');
        art.className = 'design-card__art design-card__art--' + state.orient;
        art.style.background = 'radial-gradient(circle at 30% 25%, oklch(0.6 0.2 ' + hue + ' / 0.5), oklch(0.17 0.01 30) 72%)';
        if (d.image) {
          var img = document.createElement('img');
          img.src = d.image; img.alt = d.name; img.loading = 'lazy';
          art.appendChild(img);
        } else {
          var nm = document.createElement('span');
          nm.className = 'design-card__name'; nm.textContent = d.name;
          art.appendChild(nm);
        }
        var num = document.createElement('span');
        num.className = 'design-card__num'; num.textContent = '#' + String(id).padStart(2, '0');
        art.appendChild(num);
        var body = document.createElement('div');
        body.className = 'design-card__body';
        body.innerHTML = '<h3 class="h-5" style="font-size:1rem"></h3><p class="mono-label mt-1"></p><span class="link-accent mt-3"></span>';
        body.querySelector('h3').textContent = d.name;
        body.querySelector('p').textContent = orientLabel();
        body.querySelector('span').textContent = active ? 'Price sheet below ↓' : 'See price sheet →';
        btn.appendChild(art); btn.appendChild(body);
        btn.addEventListener('click', function () { state.design = d.name; renderGrid(); renderSheet(true); });
        grid.appendChild(btn);
      });
    }

    function renderSheet(scroll) {
      if (!state.design) { sheet.hidden = true; return; }
      sheet.hidden = false;
      sheet.querySelector('[data-sheet-name]').textContent = state.design;
      sheet.querySelector('[data-sheet-meta]').textContent = orientLabel() + ', matte only, ' + cfg.minimum + ' bag minimum, ' + cfg.turnaround;
      var tbody = sheet.querySelector('tbody');
      tbody.innerHTML = '';
      var base = cfg.tiers.length ? cfg.tiers[0].each : 0;
      cfg.tiers.forEach(function (t, i) {
        var off = base ? Math.round((1 - t.each / base) * 100) : 0;
        var plus = i === cfg.tiers.length - 1 ? '+' : '';
        var tr = document.createElement('tr');
        tr.innerHTML = '<td class="num"></td><td style="font-family:var(--font-mono);font-size:.875rem"></td><td></td><td class="num right"></td><td class="right" style="padding-left:1rem"></td>';
        tr.children[0].textContent = t.qty + plus + ' bags';
        tr.children[1].textContent = money(t.each);
        tr.children[2].innerHTML = off > 0 ? '<span class="chip chip--accent">' + off + '% off</span>' : '<span class="mono-label">Base price</span>';
        tr.children[3].textContent = money(t.each * t.qty);
        var v = findVariant(cfg.variants, [orientLabel(), t.qty + ' bags']);
        if (v && v.available) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'btn-primary'; b.style.padding = '.55rem 1rem'; b.style.fontSize = '.8rem';
          b.textContent = 'Buy';
          b.setAttribute('aria-label', 'Buy ' + t.qty + ' bags of ' + state.design);
          b.addEventListener('click', function () {
            addToCart(v.id, { 'Design': state.design }, true, sheet.querySelector('[data-cart-msg]'), b);
          });
          tr.children[4].appendChild(b);
        }
        tbody.appendChild(tr);
      });
      var link = sheet.querySelector('[data-order-link]');
      if (link && link.dataset.base) {
        link.href = link.dataset.base + (link.dataset.base.indexOf('?') > -1 ? '&' : '?') +
          'product=' + encodeURIComponent('Pre-made bag design (32 min)') +
          '&size=' + encodeURIComponent(state.orient === 'standard' ? '4 x 5 standard' : '5 x 4 sideways') +
          '&details=' + encodeURIComponent('Premade design: ' + state.design);
      }
      if (scroll) sheet.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    root.querySelectorAll('[data-orient]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.orient = b.dataset.orient; state.design = null;
        root.querySelectorAll('[data-orient]').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        renderGrid(); renderSheet(false);
      });
    });
    renderGrid();
  });


  // ---------- Premade design builder ----------
  document.querySelectorAll('[data-premade-product]').forEach(function (root) {
    var cfg = readJSON(root.querySelector('[data-pm-config]'));
    if (!cfg) return;
    var $ = function (sel) { return root.querySelector(sel); };
    var fmt = function (cents) { return money(cents / 100); };
    var flavorBtns = root.querySelectorAll('[data-pm-flavors] .pm-flavor');
    var sidesBtns = root.querySelectorAll('[data-pm-sides] .pm-choice__btn');
    var sizeBtns = root.querySelectorAll('[data-pm-size] .orient');
    var urlSize = new URLSearchParams(window.location.search).get('size');
    if (urlSize) sizeBtns.forEach(function (b) { var on = b.dataset.value === urlSize; if (on) { sizeBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); x.classList.toggle('is-active', x === b); }); } });
    var logoBtns = root.querySelectorAll('[data-pm-logo] .pm-choice__btn');
    var multiBox = $('[data-pm-multi]');
    var qtyWrap = $('[data-pm-qtys]');
    var notesEl = $('[data-pm-notes]');
    var msg = $('[data-pm-msg]');
    var addBtn = $('[data-pm-add]'), checkoutBtn = $('[data-pm-checkout]');
    var stageImg = root.querySelector('.pm-stage__img');
    var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
    var minimum = cfg.minimum || 0;
    var cartBags = 0;
    var qtys = {}; // flavor -> qty
    var defaultQty = tiers.length ? tiers[0].qty : (minimum || 1);

    function pressed(list) { var out = []; list.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') out.push(b.dataset.value); }); return out; }
    function flavors() { return cfg.flavorIndex < 0 ? [null] : pressed(flavorBtns); }
    function side() { var p = pressed(sidesBtns); return p[0] || null; }
    function size() { var p = pressed(sizeBtns); return p[0] || null; }
    function wantsLogo() { return pressed(logoBtns)[0] === 'yes'; }
    function variantFor(flavor) {
      var sd = side();
      return cfg.variants.find(function (v) {
        if (cfg.flavorIndex >= 0 && v.options[cfg.flavorIndex] !== flavor) return false;
        if (cfg.sidesIndex >= 0 && v.options[cfg.sidesIndex] !== sd) return false;
        if (cfg.sizeIndex >= 0 && v.options[cfg.sizeIndex] !== size()) return false;
        return true;
      }) || null;
    }
    function tierFor(total) { var t = null; tiers.forEach(function (x) { if (total >= x.qty) t = x; }); return t; }
    function nextTier(total) { return tiers.find(function (x) { return x.qty > total; }) || null; }

    function renderQtys() {
      var list = flavors();
      qtyWrap.innerHTML = '';
      Object.keys(qtys).forEach(function (k) { if (list.indexOf(k === 'null' ? null : k) < 0) delete qtys[k]; });
      list.forEach(function (f) {
        var key = String(f);
        if (!qtys[key]) qtys[key] = defaultQty;
        var row = document.createElement('div');
        row.className = 'pm-qtyrow';
        var name = document.createElement('span');
        name.className = 'pm-qtyrow__name';
        name.textContent = f ? f : 'Bags';
        var v = variantFor(f);
        if (v && !v.available) name.textContent += ' (sold out)';
        var q = document.createElement('div');
        q.className = 'qty';
        q.innerHTML = '<button type="button" data-step="-1" aria-label="Fewer">−</button><input type="number" min="0" inputmode="numeric"><button type="button" data-step="1" aria-label="More">+</button>';
        var input = q.querySelector('input');
        input.value = qtys[key];
        input.setAttribute('aria-label', 'Bags of ' + (f || cfg.productTitle));
        input.addEventListener('input', function () { qtys[key] = Math.max(0, parseInt(input.value, 10) || 0); update(false); });
        q.addEventListener('click', function (e) {
          var b = e.target.closest('[data-step]'); if (!b) return;
          var stepSize = 8;
          var cur = parseInt(input.value, 10) || 0;
          var next = Math.max(0, cur + stepSize * parseInt(b.dataset.step, 10));
          input.value = next; qtys[key] = next; update(false);
        });
        row.appendChild(name); row.appendChild(q);
        qtyWrap.appendChild(row);
      });
      if (!list.length) {
        var p = document.createElement('p'); p.className = 'small muted'; p.textContent = 'Pick at least one flavor above.';
        qtyWrap.appendChild(p);
      }
    }

    function adding() { var n = 0; Object.keys(qtys).forEach(function (k) { n += qtys[k] || 0; }); return n; }

    function renderLadder(total) {
      var ladder = $('[data-pm-ladder]');
      var cur = tierFor(total);
      var base = variantFor(flavors()[0]) || cfg.variants[0];
      ladder.innerHTML = '';
      tiers.forEach(function (t, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('role', 'listitem');
        b.className = 'pm-rung' + (total >= t.qty ? ' is-reached' : '') + (cur === t ? ' is-current' : '');
        var plus = i === tiers.length - 1 ? '+' : '';
        b.innerHTML = '<span class="pm-rung__qty"></span><span class="pm-rung__each"></span>';
        b.children[0].textContent = t.qty + plus;
        b.children[1].textContent = base ? fmt(Math.round(base.price * (1 - t.off / 100))) + '/bag' : (t.off ? t.off + '% off' : 'Base');
        b.title = 'Set quantity so your premade total reaches ' + t.qty;
        b.addEventListener('click', function () {
          var keys = Object.keys(qtys); if (!keys.length) return;
          var need = Math.max(0, t.qty - cartBags);
          var per = Math.ceil(need / keys.length);
          keys.forEach(function (k) { qtys[k] = per; });
          renderQtys(); update(false);
        });
        ladder.appendChild(b);
      });
      var meter = $('[data-pm-meter]');
      var top = tiers.length ? tiers[tiers.length - 1].qty : 1;
      meter.style.width = Math.min(100, (total / top) * 100) + '%';
    }

    function update(rebuildQtys) {
      if (rebuildQtys) renderQtys();
      var list = flavors();
      var add = adding();
      var total = cartBags + add;
      var tier = tierFor(total);
      var off = tier ? tier.off : 0;
      var nt = nextTier(total);
      renderLadder(total);

      var subtotal = 0, ok = add > 0, soldOut = false;
      list.forEach(function (f) {
        var v = variantFor(f);
        if (!v) { ok = false; return; }
        if (!v.available && (qtys[String(f)] || 0) > 0) soldOut = true;
        subtotal += v.price * (qtys[String(f)] || 0);
      });
      var discounted = Math.round(subtotal * (1 - off / 100));
      var logoFee = (cfg.logo && wantsLogo()) ? cfg.logo.price * list.filter(function (f) { return (qtys[String(f)] || 0) > 0; }).length : 0;
      $('[data-pm-total]').textContent = fmt(discounted + logoFee);

      var first = variantFor(list[0]) || cfg.variants[0];
      if (first) {
        $('[data-pm-each]').textContent = fmt(Math.round(first.price * (1 - off / 100)));
        var was = $('[data-pm-was]'); was.hidden = !off; was.textContent = fmt(first.price);
        var badge = $('[data-pm-tierbadge]'); badge.hidden = !off; badge.textContent = off ? (tier.qty + '+ bags · ' + off + '% off') : '';
        if (first.image && stageImg && rebuildQtys) { stageImg.src = first.image; stageImg.removeAttribute('srcset'); }
      }

      var parts = [add + ' bag' + (add === 1 ? '' : 's') + (size() ? ' (' + size() + ')' : '')];
      if (list.length > 1) parts.push(list.length + ' flavors');
      if (off) parts.push(off + '% volume break');
      if (logoFee) parts.push('logo ' + fmt(logoFee));
      if (cartBags) parts.push(cartBags + ' already in cart');
      $('[data-pm-breakdown]').textContent = parts.join(' · ');

      var nudge = $('[data-pm-nudge]');
      if (nt && first) {
        nudge.innerHTML = '';
        var strong = document.createElement('strong'); strong.textContent = (nt.qty - total) + ' more bags';
        nudge.appendChild(document.createTextNode('Add ')); nudge.appendChild(strong);
        nudge.appendChild(document.createTextNode(' to drop to ' + fmt(Math.round(first.price * (1 - nt.off / 100))) + '/bag. Every premade bag in your cart counts.'));
      } else {
        nudge.textContent = total ? 'You\'re at the best price.' : '';
      }

      var warn = $('[data-pm-minwarn]');
      var below = minimum && total < minimum;
      warn.hidden = !below;
      if (below) warn.textContent = 'Premade orders start at ' + minimum + ' bags across all designs. Add ' + (minimum - total) + ' more to check out.';

      addBtn.disabled = !ok || soldOut;
      checkoutBtn.disabled = !ok || soldOut || below;
      addBtn.textContent = soldOut ? 'Sold out' : (add ? 'Add ' + add + ' bags' : 'Add to cart');

      // side price notes
      root.querySelectorAll('[data-pm-sides] .pm-choice__btn').forEach(function (b) {
        var note = b.querySelector('[data-pm-sidenote]');
        var v = cfg.variants.find(function (x) {
          return x.options[cfg.sidesIndex] === b.dataset.value && (cfg.flavorIndex < 0 || x.options[cfg.flavorIndex] === (list[0] || x.options[cfg.flavorIndex])) && (cfg.sizeIndex < 0 || x.options[cfg.sizeIndex] === size());
        });
        if (note && v) note.textContent = fmt(Math.round(v.price * (1 - off / 100))) + '/bag';
      });
      // disable flavors with no available variant for chosen side
      flavorBtns.forEach(function (b) {
        var v = variantFor(b.dataset.value);
        b.disabled = !v || !v.available;
      });
    }

    // selection handlers
    flavorBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var multi = multiBox && multiBox.checked;
        if (multi) {
          var on = b.getAttribute('aria-pressed') === 'true';
          b.setAttribute('aria-pressed', on ? 'false' : 'true');
        } else {
          flavorBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        }
        update(true);
      });
    });
    if (multiBox) multiBox.addEventListener('change', function () {
      $('[data-pm-multihint]').hidden = !multiBox.checked;
      if (!multiBox.checked) {
        var first = null;
        flavorBtns.forEach(function (x) { if (!first && x.getAttribute('aria-pressed') === 'true') first = x; });
        flavorBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === (first || flavorBtns[0]) ? 'true' : 'false'); });
      }
      update(true);
    });
    [sidesBtns, logoBtns, sizeBtns].forEach(function (group) {
      group.forEach(function (b) {
        b.addEventListener('click', function () {
          group.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); x.classList.toggle('is-active', x === b); });
          var hint = $('[data-pm-logohint]'); if (hint) hint.hidden = !wantsLogo();
          update(true);
        });
      });
    });

    function buildItems() {
      var items = [], notes = notesEl.value.trim(), withLogo = cfg.logo && wantsLogo(), logoCount = 0, names = [];
      flavors().forEach(function (f) {
        var q = qtys[String(f)] || 0; if (!q) return;
        var v = variantFor(f); if (!v) return;
        var props = {};
        if (withLogo) props['Logo'] = 'Yes, add my logo';
        if (notes) props['Notes'] = notes;
        items.push({ id: v.id, quantity: q, properties: props });
        logoCount++; names.push(f || cfg.productTitle);
      });
      if (withLogo && logoCount) items.push({ id: cfg.logo.id, quantity: logoCount, properties: { 'Design': cfg.productTitle, 'Flavors': names.join(', ') } });
      return items;
    }
    function submit(goCheckout, btn) {
      var items = buildItems(); if (!items.length) return;
      btn.disabled = true; msg.style.color = ''; msg.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); }); return r.json(); })
        .then(function () {
          if (goCheckout) { window.location.href = '/checkout'; return; }
          return loadCart().then(function () {
            msg.innerHTML = 'Added. <a class="link-accent" href="/cart">View cart →</a>';
            update(false);
          });
        })
        .catch(function (e) { msg.textContent = e.message + '. Try again or contact the shop.'; msg.style.color = 'var(--destructive)'; })
        .finally(function () { btn.disabled = false; update(false); });
    }
    addBtn.addEventListener('click', function () { submit(false, addBtn); });
    checkoutBtn.addEventListener('click', function () {
      // add current selection (if any) then go to checkout
      if (adding() > 0) submit(true, checkoutBtn); else window.location.href = '/checkout';
    });

    function loadCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        cartBags = 0;
        c.items.forEach(function (it) { if (it.product_type === cfg.productType) cartBags += it.quantity; });
        var link = document.querySelector('a[href="/cart"].icon-btn');
        if (link) {
          var count = link.querySelector('.cart-count');
          if (c.item_count > 0) { if (!count) { count = document.createElement('span'); count.className = 'cart-count'; link.appendChild(count); } count.textContent = c.item_count; }
        }
      }).catch(function () {});
    }

    // gallery
    root.querySelectorAll('[data-pm-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (stageImg) { stageImg.src = t.dataset.src; stageImg.removeAttribute('srcset'); }
        root.querySelectorAll('[data-pm-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
    var lb = $('[data-pm-lightbox]');
    var zoom = $('[data-pm-zoom]');
    if (lb && zoom && stageImg && typeof lb.showModal === 'function') {
      zoom.addEventListener('click', function () { $('[data-pm-lightimg]').src = stageImg.currentSrc || stageImg.src; lb.showModal(); });
      $('[data-pm-close]').addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    }

    update(true);
    loadCart().then(function () { update(false); });
  });


  // Premade grid: size filter panels
  document.querySelectorAll('[data-pm-grid]').forEach(function (root) {
    var panels = root.querySelectorAll('[data-pm-sizefilter] .orient');
    if (!panels.length) return;
    var cards = root.querySelectorAll('[data-pm-card]');
    var none = root.querySelector('[data-pm-none]');
    var count = root.querySelector('[data-pm-count]');
    function apply(value) {
      var shown = 0;
      cards.forEach(function (c) {
        var sizes = (c.dataset.sizes || '').split('|').filter(Boolean);
        var ok = !sizes.length || sizes.indexOf(value) > -1;
        c.hidden = !ok;
        if (!c.dataset.base) c.dataset.base = c.getAttribute('href');
        c.setAttribute('href', sizes.length ? c.dataset.base + '?size=' + encodeURIComponent(value) : c.dataset.base);
        if (ok) shown++;
      });
      if (none) none.hidden = shown > 0;
      if (count) count.textContent = shown + ' design' + (shown === 1 ? '' : 's');
      panels.forEach(function (p) { var on = p.dataset.value === value; p.classList.toggle('is-active', on); p.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    }
    panels.forEach(function (p) { p.addEventListener('click', function () { apply(p.dataset.value); }); });
    apply(panels[0].dataset.value);
  });


  // Quote request: quick-pick chips fill the product menu
  document.querySelectorAll('[data-quote-chip]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var select = document.querySelector('[data-quote-product]');
      if (!select) return;
      var match = Array.prototype.find.call(select.options, function (o) { return o.value.toLowerCase().indexOf(chip.dataset.value.toLowerCase()) > -1; });
      if (match) select.value = match.value;
      document.querySelectorAll('[data-quote-chip]').forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      select.focus();
    });
  });

  // Contact form: prefill from ?product=&size=&quantity=&details=
  document.querySelectorAll('#ContactForm').forEach(function (form) {
    var params = new URLSearchParams(window.location.search);
    [['product', 'contact[Product]'], ['size', 'contact[Bag size]'], ['quantity', 'contact[Quantity]'], ['details', 'contact[body]']].forEach(function (pair) {
      var v = params.get(pair[0]);
      if (!v) return;
      var el = form.querySelector('[name="' + pair[1] + '"]');
      if (!el) return;
      if (el.tagName === 'SELECT') {
        for (var i = 0; i < el.options.length; i++) if (el.options[i].value === v) el.selectedIndex = i;
      } else { el.value = v; }
    });
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyStep, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Product gallery thumbs + variant select
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var main = root.querySelector('.js-main-image');
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.src; main.srcset = '';
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
    var variantsEl = root.querySelector('script[data-variants]');
    var variants = variantsEl ? readJSON(variantsEl) : null;
    var selects = root.querySelectorAll('[data-option-select]');
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add]');
    if (!variants || !selects.length) return;
    function onChange() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.textContent = v.price_formatted;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.image && main) { main.src = v.image; main.srcset = ''; }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    selects.forEach(function (s) { s.addEventListener('change', onChange); });
  });

  // Cart: auto-submit on qty change
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[name="updates[]"]')) form.submit();
    });
  });
})();
